export default __webpack_public_path__ + "static/avatar10-bd451cb1950c68e9e5bab549c38f50fc.png";